/**
 * Every campaign address the site renders as a QR code.
 *
 * A member per destination rather than a free-form URL, so a printed code and
 * the one on screen can never drift apart: both resolve through the same entry.
 */
export enum CharityQrTarget {
  Donate = "donate",
  ScreenshotApps = "screenshotApps",
  GroupRide = "groupRide",
  RideTogether = "rideTogether",
  HowToReport = "howToReport",
}
